import { useCallback } from 'react';
import { useFormikContext } from 'formik';
import { ItemCategory } from '@prisma/client';
import { CheckoutFormValues } from '../../types/appointments';

export interface OrderItemInput {
  itemId: string;
  name: string;
  price: number;
  category?: ItemCategory;
}

/** Adds an items row to the cart, merging quantity onto an existing line. */
function useAddOrderItem() {
  const { values, setFieldValue } = useFormikContext<CheckoutFormValues>();

  return useCallback(
    (item: OrderItemInput, quantity = 1) => {
      const lines = values.customOrderItems ?? [];
      const existing = lines.some(line => line.itemId === item.itemId);

      if (existing) {
        setFieldValue(
          'customOrderItems',
          lines.map(line =>
            line.itemId === item.itemId
              ? { ...line, quantity: line.quantity + quantity }
              : line,
          ),
        );
        return;
      }

      setFieldValue('customOrderItems', [
        ...lines,
        {
          id: item.itemId,
          itemId: item.itemId,
          name: item.name,
          price: item.price,
          quantity,
          category: item.category,
        },
      ]);
    },
    [values.customOrderItems, setFieldValue],
  );
}

export default useAddOrderItem;
